import { MockDebug } from '@tino-frontend/mocks'
import { MockDebugBill } from './mocks-msw-bill'
import { MockDebugUser } from './mocks-msw-user'
import { MockDebugTutorial } from './mocks-msw-tutorial'
import { MockDebugCreditLimitSituation } from './mocks-msw-credit-limit-situation'
import { MockDebugInvoices } from './mocks-msw-invoices'

import { MockDebugQuizSituation } from './mocks-msw-quiz-situation'
import { MockDebugCheckout } from './mocks-msw-checkout'
import { MockDebugContract } from './mocks-msw-contract-collecting'
import { MockDebugReceivableDetail } from './mocks-msw-receivable-detail'
import { MockDebugTrial } from './mocks-msw-trial'
import { MockDebugPayment } from './mocks-msw-payment'
import { MockDebugSalespersonApp } from './mocks-msw-salesperson-app'
import { MockDebugPaymentObligations } from './mocks-msw-payment-obligations'
import { MockDebugMerchant } from './mocks-msw-merchant'

export * from './mock-debug.container'

interface SelectMockMsw {
  title: string
  list: MockDebug[]
}

export const mockDebugAllMocks: SelectMockMsw[] = [
  {
    title: 'App do Vendedor',
    list: MockDebugSalespersonApp,
  },
  {
    title: 'Bill',
    list: MockDebugBill,
  },
  {
    title: 'Invoices',
    list: MockDebugInvoices,
  },
  {
    title: 'Checkout',
    list: MockDebugCheckout,
  },
  {
    title: 'User',
    list: MockDebugUser,
  },
  {
    title: 'Tutorial',
    list: MockDebugTutorial,
  },
  {
    title: 'CreditLimitSituation',
    list: MockDebugCreditLimitSituation,
  },
  {
    title: 'Quiz',
    list: MockDebugQuizSituation,
  },
  {
    title: 'Contract Status',
    list: MockDebugContract,
  },
  {
    title: 'Receivable Details',
    list: MockDebugReceivableDetail,
  },
  {
    title: 'App do Vendedor e Financeiro',
    list: MockDebugTrial,
  },
  {
    title: 'Payment',
    list: MockDebugPayment,
  },
  {
    title: 'Payment Obligations',
    list: MockDebugPaymentObligations,
  },
  {
    title: 'Lojista (Merchant)',
    list: MockDebugMerchant,
  },
]
